<template>
  <PageSeoData
    :title="
      $t('page_seo_data.facilities_table.title')
    "
    :description="
      $t('page_seo_data.facilities_table.description')
    "
  />
  <FacilitiesTableSection />
</template>

<script setup lang="ts">
import FacilitiesTableSection from "~/components/sections/FacilitiesTableSection.vue";
import PageSeoData from "~/components/pageSeoData/PageSeoData.vue";
</script>
